import { supabase } from '../supabase/supabaseClient.js';

/**
 * Fetches a user's profile from the database (frontend-safe).
 * @param {string} userId - Supabase Auth user id
 * @returns {Promise<object|null>} - The user profile row or null if not found.
 */
export async function getUserProfile(userId) {
  const { data: profile, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single();

  if (error && error.code !== 'PGRST116') {
    console.error('Error fetching profile:', error);
    throw error;
  }

  return profile;
}

/**
 * Ensure a user profile exists for the given user (frontend-safe; will fail if RLS blocks writes).
 * @param {string} userId - Supabase Auth user id
 * @param {string} email - User email
 * @returns {Promise<object>} - The user profile row
 */
export async function ensureUserProfile(userId, email) {
  const profile = await getUserProfile(userId);

  if (profile) {
    return profile;
  }

  // If no profile, insert a default free profile
  const { data: newProfile, error: insertError } = await supabase
    .from('profiles')
    .insert([
      {
        id: userId,
        email,
        plan: 'free',
        subscription_status: 'inactive',
        onboarding_complete: false,
        stripe_customer_id: null,
      },
    ])
    .select()
    .single();

  if (insertError) {
    console.error('Error creating default profile:', insertError);
    throw insertError;
  }

  return newProfile;
}
